/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import { View } from 'backbone.marionette';

import tmplErrorView from './ErrorView.hbs';

const ErrorView = View.extend({
  template: tmplErrorView,

  className: 'error-page',

  initialize() {
    if(!this.model.get('errorMessage')) {
      this.model.set('errorMessage', 'An error has occurred. Please contact an administrator.')
    }
  }
});

export default ErrorView;
